import i18n from "@/locales";

export default [
  { value: "1", name: String(i18n.t("general.primavera")) },
  { value: "2", name: String(i18n.t("general.expovina")) }
];
